<script lang="ts" setup>
import { FormBackButton, FormProgressBar, FormProgressSpacing } from '@/components/common';

interface Props {
  showBackBtn?: boolean;
  backBtnText?: string;
  formStep: number;
}

const props = withDefaults(defineProps<Props>(), {
  showBackBtn: true,
  backBtnText: '',
});

// More explicit event typing
const emit = defineEmits<{
  onBackClick: [];
}>();

// Direct event handler - more concise
const handleBackClick = () => emit('onBackClick');
</script>

<template>
  <div :class="$style.wrapper">
    <FormBackButton
      v-if="showBackBtn"
      :class="$style.backButton"
      :text="backBtnText"
      @onBack="handleBackClick"
    />
    <div v-else></div>
    <FormProgressSpacing>
      <FormProgressBar :formStep="formStep" />
    </FormProgressSpacing>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  height: 52px;
}

.backButton {
  justify-self: start;
}
</style>
